/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime';
import { CountUnreadMessageThreadResultRepresentationFromJSON, MessageRepresentationFromJSON, MessageThreadRepresentationFromJSON, SetCursorMessageThreadRequestToJSON, SetMessageStatusMessageThreadRequestToJSON, } from '../models';
/**
 *
 */
var MessageThreadsApi = /** @class */ (function (_super) {
    __extends(MessageThreadsApi, _super);
    function MessageThreadsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get message thread
     */
    MessageThreadsApi.prototype._deleteRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.messageThreadId === null || requestParameters.messageThreadId === undefined) {
                            throw new runtime.RequiredError('messageThreadId', 'Required parameter requestParameters.messageThreadId was null or undefined when calling _delete.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/messageThreads/{messageThreadId}".replace("{".concat('messageThreadId', "}"), encodeURIComponent(String(requestParameters.messageThreadId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get message thread
     */
    MessageThreadsApi.prototype._delete = function (messageThreadId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._deleteRaw({ messageThreadId: messageThreadId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Append message to message thread
     */
    MessageThreadsApi.prototype.appendMessageRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.messageThreadId === null || requestParameters.messageThreadId === undefined) {
                            throw new runtime.RequiredError('messageThreadId', 'Required parameter requestParameters.messageThreadId was null or undefined when calling appendMessage.');
                        }
                        if (requestParameters.message === null || requestParameters.message === undefined) {
                            throw new runtime.RequiredError('message', 'Required parameter requestParameters.message was null or undefined when calling appendMessage.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        consumes = [{ contentType: 'multipart/form-data' }];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        // use FormData to transmit files using content-type "multipart/form-data"
                        useForm = canConsumeForm;
                        // use FormData to transmit files using content-type "multipart/form-data"
                        useForm = canConsumeForm;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.message !== undefined) {
                            formParams.append('message', requestParameters.message);
                        }
                        if (requestParameters.file !== undefined) {
                            formParams.append('file', requestParameters.file);
                        }
                        if (requestParameters.files) {
                            requestParameters.files.forEach(function (element) {
                                formParams.append('files', element);
                            });
                        }
                        return [4 /*yield*/, this.request({
                                path: "/messageThreads/{messageThreadId}/messages".replace("{".concat('messageThreadId', "}"), encodeURIComponent(String(requestParameters.messageThreadId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Append message to message thread
     */
    MessageThreadsApi.prototype.appendMessage = function (messageThreadId, message, file, files) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.appendMessageRaw({ messageThreadId: messageThreadId, message: message, file: file, files: files })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Count unread message threads
     */
    MessageThreadsApi.prototype.countUnreadRaw = function () {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/messageThreads/unread",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return CountUnreadMessageThreadResultRepresentationFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Count unread message threads
     */
    MessageThreadsApi.prototype.countUnread = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.countUnreadRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create message thread
     */
    MessageThreadsApi.prototype.createRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.messageThread === null || requestParameters.messageThread === undefined) {
                            throw new runtime.RequiredError('messageThread', 'Required parameter requestParameters.messageThread was null or undefined when calling create.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        consumes = [{ contentType: 'multipart/form-data' }];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        // use FormData to transmit files using content-type "multipart/form-data"
                        useForm = canConsumeForm;
                        // use FormData to transmit files using content-type "multipart/form-data"
                        useForm = canConsumeForm;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.messageThread !== undefined) {
                            formParams.append('messageThread', requestParameters.messageThread);
                        }
                        if (requestParameters.file !== undefined) {
                            formParams.append('file', requestParameters.file);
                        }
                        if (requestParameters.files) {
                            requestParameters.files.forEach(function (element) {
                                formParams.append('files', element);
                            });
                        }
                        return [4 /*yield*/, this.request({
                                path: "/messageThreads",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Create message thread
     */
    MessageThreadsApi.prototype.create = function (messageThread, file, files) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRaw({ messageThread: messageThread, file: file, files: files })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get message thread
     */
    MessageThreadsApi.prototype.getByIdRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.messageThreadId === null || requestParameters.messageThreadId === undefined) {
                            throw new runtime.RequiredError('messageThreadId', 'Required parameter requestParameters.messageThreadId was null or undefined when calling getById.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/messageThreads/{messageThreadId}".replace("{".concat('messageThreadId', "}"), encodeURIComponent(String(requestParameters.messageThreadId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return MessageThreadRepresentationFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get message thread
     */
    MessageThreadsApi.prototype.getById = function (messageThreadId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getByIdRaw({ messageThreadId: messageThreadId })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Find message threads
     */
    MessageThreadsApi.prototype.listRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.size === null || requestParameters.size === undefined) {
                            throw new runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined when calling list.');
                        }
                        queryParameters = {};
                        if (requestParameters.anchorPrefix !== undefined) {
                            queryParameters['anchorPrefix'] = requestParameters.anchorPrefix;
                        }
                        if (requestParameters.lastUpdateTime !== undefined) {
                            queryParameters['lastUpdateTime'] = requestParameters.lastUpdateTime.toISOString();
                        }
                        if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/messageThreads",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(MessageThreadRepresentationFromJSON); })];
                }
            });
        });
    };
    /**
     * Find message threads
     */
    MessageThreadsApi.prototype.list = function (size, anchorPrefix, lastUpdateTime, id) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listRaw({
                            size: size,
                            anchorPrefix: anchorPrefix,
                            lastUpdateTime: lastUpdateTime,
                            id: id,
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Find message thread messages
     */
    MessageThreadsApi.prototype.listMessagesRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.messageThreadId === null || requestParameters.messageThreadId === undefined) {
                            throw new runtime.RequiredError('messageThreadId', 'Required parameter requestParameters.messageThreadId was null or undefined when calling listMessages.');
                        }
                        if (requestParameters.size === null || requestParameters.size === undefined) {
                            throw new runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined when calling listMessages.');
                        }
                        queryParameters = {};
                        if (requestParameters.order !== undefined) {
                            queryParameters['order'] = requestParameters.order;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/messageThreads/{messageThreadId}/messages".replace("{".concat('messageThreadId', "}"), encodeURIComponent(String(requestParameters.messageThreadId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(MessageRepresentationFromJSON); })];
                }
            });
        });
    };
    /**
     * Find message thread messages
     */
    MessageThreadsApi.prototype.listMessages = function (messageThreadId, size, order) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listMessagesRaw({ messageThreadId: messageThreadId, size: size, order: order })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update message thread cursor
     */
    MessageThreadsApi.prototype.setCursorRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.messageThreadId === null || requestParameters.messageThreadId === undefined) {
                            throw new runtime.RequiredError('messageThreadId', 'Required parameter requestParameters.messageThreadId was null or undefined when calling setCursor.');
                        }
                        if (requestParameters.setCursorMessageThreadRequest === null ||
                            requestParameters.setCursorMessageThreadRequest === undefined) {
                            throw new runtime.RequiredError('setCursorMessageThreadRequest', 'Required parameter requestParameters.setCursorMessageThreadRequest was null or undefined when calling setCursor.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/messageThreads/{messageThreadId}/cursor".replace("{".concat('messageThreadId', "}"), encodeURIComponent(String(requestParameters.messageThreadId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: SetCursorMessageThreadRequestToJSON(requestParameters.setCursorMessageThreadRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update message thread cursor
     */
    MessageThreadsApi.prototype.setCursor = function (messageThreadId, setCursorMessageThreadRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setCursorRaw({
                            messageThreadId: messageThreadId,
                            setCursorMessageThreadRequest: setCursorMessageThreadRequest,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Set message status
     */
    MessageThreadsApi.prototype.setMessageStatusRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.messageThreadId === null || requestParameters.messageThreadId === undefined) {
                            throw new runtime.RequiredError('messageThreadId', 'Required parameter requestParameters.messageThreadId was null or undefined when calling setMessageStatus.');
                        }
                        if (requestParameters.messageOrder === null || requestParameters.messageOrder === undefined) {
                            throw new runtime.RequiredError('messageOrder', 'Required parameter requestParameters.messageOrder was null or undefined when calling setMessageStatus.');
                        }
                        if (requestParameters.setMessageStatusMessageThreadRequest === null ||
                            requestParameters.setMessageStatusMessageThreadRequest === undefined) {
                            throw new runtime.RequiredError('setMessageStatusMessageThreadRequest', 'Required parameter requestParameters.setMessageStatusMessageThreadRequest was null or undefined when calling setMessageStatus.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/messageThreads/{messageThreadId}/messages/{messageOrder}/status"
                                    .replace("{".concat('messageThreadId', "}"), encodeURIComponent(String(requestParameters.messageThreadId)))
                                    .replace("{".concat('messageOrder', "}"), encodeURIComponent(String(requestParameters.messageOrder))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: SetMessageStatusMessageThreadRequestToJSON(requestParameters.setMessageStatusMessageThreadRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Set message status
     */
    MessageThreadsApi.prototype.setMessageStatus = function (messageThreadId, messageOrder, setMessageStatusMessageThreadRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setMessageStatusRaw({
                            messageThreadId: messageThreadId,
                            messageOrder: messageOrder,
                            setMessageStatusMessageThreadRequest: setMessageStatusMessageThreadRequest,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return MessageThreadsApi;
}(runtime.BaseAPI));
export { MessageThreadsApi };
